import { alternatesToLinks } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

import { buildLandingPageAlternates } from "./build-landing-page-alternates";

export interface LandingPageHeadInput {
  locale: ViewerLocale;
  metadata: {
    title: string;
    description: string;
    ogAlt: string;
  };
  slug: string;
}

/** Builds the localized head for Google Ads landing pages, which stay out of organic search. */
export async function buildLandingPageHead(input: LandingPageHeadInput) {
  const alternates = buildLandingPageAlternates(input.locale, input.slug);

  return {
    meta: await buildPagePreviewMetaTags(
      {
        title: input.metadata.title,
        description: input.metadata.description,
        canonicalUrl: alternates.canonical,
      },
      {
        robots: "noindex,follow",
        openGraph: {
          type: "website",
          siteName: "Garimpa.Club",
          image: { width: "1200", height: "630", alt: input.metadata.ogAlt },
        },
        twitter: { card: "summary_large_image" },
      },
      { locale: input.locale },
    ),
    links: alternatesToLinks(alternates),
  };
}
